window.CadastrarAtendimentoClienteController = ControllerBase.extend({
    name: 'CadastrarAtendimentoClienteController',
    framework: 'knockout',
    ajax: function() {
        return {
            url: '/AtendimentoCliente/_Cadastro',
            type: 'get'
        }
    },

    newModel: function() {

        return {
            Codigo: null,
            CodigoAtividade: null,
            CodigoCliente: null,
            CodigoMotivo: null,
            CodigoVendedor: null,
            Contato: null,
            DataProximoContato: null,
            NomeCliente: null,
            NumeroPedido: null,
            Telefone: null,
            Texto: null,
            permitidoAlterarCliente: true
        };

    },

    initialize: function () {
        this.setModel(this.newModel());
    },
    antesBinding: function () {

        this.addActionButton({
            text: "Limpar",
            'class': "icone-excluir separador",
            click: $.proxy(this.limpar, this)
        }, true);

        this.select2Vendedores = {
            ajax: {
                url: '/Vendedor/ListarPorNome',
                type: 'post',
                data: function (params) {
                    return {
                        nome: params.term
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return { id: i.Codigo, text: i.Nome };
                        })
                    };
                }
            },
            minimumInputLength: 1
        };

        this.select2Atividade = {
            ajax: {
                url: '/AtendimentoCliente/ListarAtividadesPorDescricao',
                type: 'post',
                data: function (params) {
                    return {
                        descricao: params.term
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return { id: i.Codigo, text: i.Descricao };
                        })
                    };
                }
            },
            minimumInputLength: 1
        };

        this.select2Motivo = {
            ajax: {
                url: '/AtendimentoCliente/ListarMotivosPorNome',
                type: 'post',
                data: function (params) {
                    return {
                        nome: params.term
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return { id: i.Codigo, text: i.Nome };
                        })
                    };
                }
            },
            minimumInputLength: 1
        };

        if (this.cliente) {
            this.model.CodigoCliente(this.cliente.get('Codigo'));
            this.model.NomeCliente(this.cliente.get('Nome'));
            this.model.permitidoAlterarCliente(false);
        }

        if (this.vendedor) {
            this.model.CodigoVendedor(this.vendedor.Codigo);
            $('#form-cadastrar-atendimento-cliente select[name=Vendedor]').append($('<option>',
            {
                value: this.vendedor.Codigo,
                text: this.vendedor.Nome
            }));
        }

    },
    aposBinding: function () {
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },
    limpar: function () {
        if (!this.vendedor) {
            this.removerVendedor();
        }
        if (!this.cliente) {
            this.model.CodigoCliente(undefined);
            this.model.NomeCliente(undefined);
        }
        this.removerAtividade();
        this.removerMotivo();
        this.model.Contato(undefined);
        this.model.DataProximoContato(undefined);
        this.model.Telefone(undefined);
        this.model.Texto(undefined);
    },
    removerVendedor: function () {
        $('#form-cadastrar-atendimento-cliente select[name=Vendedor]').val(null);
        this.model.CodigoVendedor(undefined);
    },
    removerAtividade: function () {
        $('#form-cadastrar-atendimento-cliente select[name=Atividade]').val(null);
        this.model.CodigoAtividade(undefined);
    },
    removerMotivo: function () {
        $('#form-cadastrar-atendimento-cliente select[name=Motivo]').val(null);
        this.model.CodigoMotivo(undefined);
    },
    pesquisarCliente: function () {
        this.pesquisarClientesController = this.showView({
            region: {
                name: "pesquisarClientesCadastrarAtendimentoClienteRegion",
                selector: "#pesquisar-clientes-cadastrar-atendimento-cliente-region"
            },
            controller: {
                type: PesquisarClientesController,
                args: {
                    clienteSelecionadoCallbackView: $.proxy(this.clienteSelecionado, this)
                }
            }
        });
    },
    clienteSelecionado: function (cliente) {
        if (!cliente) {
            return;
        }
        this.model.CodigoCliente(cliente.get("Codigo"));
        this.model.NomeCliente(cliente.get("Nome"));
        this.pesquisarClientesController.hide();
        this.show();
    },
    removerCliente: function () {
        this.model.CodigoCliente(undefined);
        this.model.NomeCliente(undefined);
    },
    salvar: function() {
        if (!global.isFormValid("#form-cadastrar-atendimento-cliente")) {
            return;
        }
        var acao = this.model.Codigo() != 0 ? 'atualizado' : 'criado';
        var model = this.toJS(this.model);
        var self = this;

        global.ajax({
            url: '/AtendimentoCliente/Salvar',
            type: 'post',
            data: global.toJSONString({ salvarContract: model }),
            success: function (data) {
                if (!data || data.HasErrors) {
                    return;
                }
                global.showSuccessMessage('Atendimento ' + acao + ' com sucesso');
                if (self.salvarCallback) {
                    self.salvarCallback();
                }
            }
        });
    }
});